import { Box, Input, Text } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import ThumbImageUpload from "../../../Dropzone/ThumbImageUpload";
import { last } from "lodash";
import RelevantSkill from "../RelevantSkill";

const BasicFields = ({ book, control, errors, register }) => {

  return (
    <>
      <Box>
        <Box mt="30px">
          <Text fontSize={{ base: "fs.12", md: "fs.14", lg: "fs.16" }} fontWeight="fw.500">Title</Text>
          <Controller
            name="title"
            control={control}
            rules={{ required: true }}
            render={({ field }) =>
              <Input {...field} placeholder="Enter Ebook name" height="50px" _hover={{ borderColor: "#713EDD" }} background="#F7FAFC" mt="8px" _focusVisible={{ borderColor: "#713EDD" }} />
            }
          />
        </Box>
        <Box mt="30px">
          <Text fontSize={{ base: "fs.12", md: "fs.14", lg: "fs.16" }} fontWeight="fw.500">Thumbnail Image</Text>
          <Controller
            name="thumbnailUrl"
            control={control}
            render={({ field }) =>
              <>
                <ThumbImageUpload
                  {...field}
                  innerMessage='Upload Thumbnail Image'
                  acceptedFiles={{ 'image/*': ['jpg', 'jpeg', 'png', '.webp'] }}
                  maxFiles={1}
                  defaultValue={process.env.REACT_APP_THUMBNAIL_URL + book.thumbnailUrl}
                  onRemove={() => field.onChange('')}
                  onUpload={(uploadObject) => {
                    field.onChange(last(uploadObject?.url?.split?.('/')));
                  }}
                />
                {errors.thumbnailUrl?.message && <Text color="red.500" fontSize={'fs.14'}>{errors.thumbnailUrl.message}</Text>}
              </>
            }
          />
        </Box>
        <Box mt="30px">
          <Text fontSize={{ base: "fs.12", md: "fs.14", lg: "fs.16" }} fontWeight="fw.500">PDF File</Text>
          <Controller
            name="pdfUrl"
            control={control}
            render={({ field }) =>
              <>
                <ThumbImageUpload
                  {...field}
                  innerMessage='Upload PDF File'
                  acceptedFiles={{ 'application/pdf': ['.pdf'] }}
                  maxFiles={1}
                  isPDF={true}
                  maxSize={1024 * 1024 * 500}
                  defaultValue={book.pdfUrl}
                  onRemove={() => field.onChange('')}
                  onUpload={(uploadObject) => {
                    field.onChange(last(uploadObject?.url?.split?.('/')));
                  }}
                />
                {errors.pdfUrl?.message && <Text color="red.500" fontSize={'fs.14'}>{errors.pdfUrl.message}</Text>}
              </>
            }
          />
        </Box>
        <Box mt="30px">
          <Text fontSize={{ base: "fs.12", md: "fs.14", lg: "fs.16" }} fontWeight="fw.500">Relevant Skill</Text>
          <Controller
            height="50px"
            name="relevantSkills"
            control={control}
            render={({ field }) => (
              <RelevantSkill skillVal={book.relevantSkills} register={register} field={field} />
            )}
          />
        </Box>
      </Box>
    </>);
};
export default BasicFields;